export default "__VITE_ASSET__tkuvp5rS__"